import { BorderStyle } from '../../gen-src/preslayer/Enums';
import { StyledBoxModel } from '../models/StyledBoxModel';

// Class representing a border definition: side, width, style and color.
// Includes utility property for converting to CssDictionary, and back to StyledBoxPresModel, and method that maps BorderStyle to it's respective css value.
export enum BorderSide {
  All,
  Top,
  Left,
  Right,
  Bottom,
}

export class BorderDefinition {
  private static readonly borderLookup: Map<BorderStyle, string> = new Map<BorderStyle, string>([
    [BorderStyle.None, 'none'],
    [BorderStyle.Hidden, 'hidden'],
    [BorderStyle.Dotted, 'dotted'],
    [BorderStyle.Dashed, 'dashed'],
    [BorderStyle.Solid, 'solid'],
    [BorderStyle.Double, 'double'],
    [BorderStyle.Groove, 'groove'],
    [BorderStyle.Ridge, 'ridge'],
    [BorderStyle.Inset, 'inset'],
    [BorderStyle.Outset, 'outset'],
  ]);

  public readonly width: number;
  public readonly style: BorderStyle;
  public readonly color: string;
  public readonly side: BorderSide;

  public constructor(width: number, style: BorderStyle, color: string, side: BorderSide) {
    this.width = width;
    this.style = style;
    this.color = color;
    this.side = side;
  }

  public hasColor(): boolean {
    return this.color !== StyledBoxModel.transparent;
  }

  public hasWidth(): boolean {
    return this.width > 0;
  }

  public hasStyle(): boolean {
    return this.style !== BorderStyle.None;
  }

  public static borderStyleToCss(borderStyle: BorderStyle): string {
    return this.borderLookup.get(borderStyle) ?? 'none';
  }
}
